import { FormControl, TextField } from '@mui/material';

const ReportDateTextField = ({ value }: { value: string }) => (
  <FormControl>
    <TextField
      label="Report Date"
      id="report-date"
      variant="standard"
      disabled
      value={value}
    />
  </FormControl>
);

export default ReportDateTextField;
